import React from 'react';

const DisconnectedIcon = ({ width = 25, height = 25 }) => (
  <svg width={width} height={height} viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M6.83051 16.7853C4.43932 16.7853 2.5 14.8663 2.5 12.4991C2.5 10.1329 4.43932 8.21387 6.83051 8.21387H10.1191" stroke="#F05146" strokeWidth="1.6" strokeLinecap="round"/>
    <path d="M18.0532 8.21387C20.5095 8.21387 22.4999 10.1329 22.4999 12.4991C22.4999 14.8663 20.5095 16.7853 18.0532 16.7853H14.8809" stroke="#F05146" strokeWidth="1.6" strokeLinecap="round"/>
    <path d="M15.8337 5.35693L9.16699 19.6427" stroke="#F05146" strokeWidth="1.6" strokeLinecap="round"/>
  </svg>
);

export default DisconnectedIcon;
